// Les 34 thèmes CliftonStrengths (Gallup) regroupés par domaine.
// Source officielle : https://www.gallup.com/cliftonstrengths/
// Libellés en français — alignés sur la traduction officielle Gallup FR.

export type GallupDomain =
  | 'strategic'
  | 'influencing'
  | 'relationship'
  | 'executing'

export const GALLUP_DOMAIN_LABELS: Record<GallupDomain, string> = {
  strategic: 'Pensée stratégique',
  influencing: 'Influence',
  relationship: 'Relations interpersonnelles',
  executing: 'Exécution',
}

export const GALLUP_STRENGTHS_BY_DOMAIN: Record<GallupDomain, readonly string[]> = {
  strategic: [
    'Analyse',
    'Apprentissage',
    'Contexte',
    'Futuriste',
    'Idéation',
    'Intellection',
    'Input',
    'Stratégie',
  ],
  influencing: [
    'Activateur',
    'Affirmation de soi',
    'Charisme',
    'Communication',
    'Compétition',
    'Maximisation',
    'Significativité',
    'Volonté',
  ],
  relationship: [
    'Adaptabilité',
    'Connexion',
    'Développeur',
    'Empathie',
    'Harmonie',
    'Inclusion',
    'Individualisation',
    'Positivité',
    'Relationnel',
  ],
  executing: [
    'Arrangeur',
    'Croyance',
    'Discipline',
    'Équité',
    'Focalisation',
    'Prudence',
    'Réalisateur',
    'Responsabilité',
    'Restaurateur',
  ],
}

export const GALLUP_STRENGTHS: readonly string[] = Object.values(
  GALLUP_STRENGTHS_BY_DOMAIN,
).flat()

const GALLUP_SET = new Set(GALLUP_STRENGTHS)

export function isValidStrength(value: string): boolean {
  return GALLUP_SET.has(value)
}
